export default class Kunde {
    // DO NOT CHANGE
    className = "Kunde";

    Vorname: string = '';
    Nachname: string = '';
    Strasse: string = '';
    Hausnummer: string = '';
    PLZ: string = '';
    Ort: string = '';
    EMailAdresse: string = '';
    Telefonnummer: string = '';
    Liefertyp: string = '';
    Kundennummer: string = '';
    HerstellerLiefertyp: string = '';
    DirektBeiHaendler: boolean = false;
    agbChecked: boolean = false;
    dsChecked: boolean = false;
    DirektBeiHaendler: boolean = false;

    constructor() {
    }

    validate() {
        const invalid = [];
        if (!this.validateMinLength()) invalid.push("Nachname");
        if (!this.validateMail()) invalid.push("Mail");
        if (!this.validatePhone()) invalid.push("Telefonnummer");
        if (!this.validateLiefertyp()) invalid.push("Liefertyp");
        if (!this.validateCheckboxesChecked()) invalid.push("Datenschutz");
        return invalid;
    }

    get isValid() {
        return this.validate().length === 0;
    }

    validateMinLength(){
        return this.Nachname.length >= 1;
    }

    validatePhone() {
        return /\d+/.test(this.Telefonnummer)
    }

    validateLiefertyp() {
        return this.Liefertyp !== '';
    }

    validateCheckboxesChecked() {
        return this.dsChecked;
    }

    validateMail() {
        return this.EMailAdresse.indexOf("@") > 0
            && this.EMailAdresse.length >= 3;
    }

    fromJson(json) {
        this.Vorname = json.Vorname || '';
        this.Nachname = json.Nachname || '';
        this.Strasse = json.Strasse || '';
        this.Hausnummer = json.Hausnummer || '';
        this.PLZ = json.PLZ || '';
        this.Ort = json.Ort || '';
        this.EMailAdresse = json.EMailAdresse || '';
        this.Telefonnummer = json.Telefonnummer || '';
        this.DirektBeiHaendler = json.DirektBeiHaendler || false;
        return this;
    }

    toJson() {
        return {
            className: this.className,
            Vorname: this.Vorname,
            Nachname: this.Nachname,
            Strasse: this.Strasse,
            Hausnummer: this.Hausnummer,
            PLZ: this.PLZ,
            Ort: this.Ort,
            EMailAdresse: this.EMailAdresse,
            Telefonnummer: this.Telefonnummer,
            agbChecked: this.agbChecked,
            dsChecked: this.dsChecked,
            DirektBeiHaendler : this.DirektBeiHaendler,
            isHaendler: this.isHaendler
        }
    }

    iterate(iterator) {
        iterator(this);
    }

}